import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "documents",
  "use": "documents-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"documents\"><path d=\"M26 7h-3V4a1 1 0 00-1-1H6a1 1 0 00-1 1v20a1 1 0 001 1h3v3a1 1 0 001 1h16a1 1 0 001-1V8a1 1 0 00-1-1zM9 8v15H7V5h14v2H10a1 1 0 00-1 1zm16 19H11V9h14z\" /><path d=\"M13 11h10v2H13zM13 15h10v2H13zM13 19h10v2H13zM13 23h10v2H13z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/documents.svg
// module id = QOya
// module chunks = 39 44